import {classNames, React, observer, toJS, Fragment} from '@api'
import {Icon, Spinner} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import {useFieldRendererStore} from '@design-board/stores'
import * as css from './SyncFieldButton.css'
import {PrimaryButton, PrimaryIconButton} from 'centric-ui-components'
import ReactTimeago from 'react-timeago'
import { CatalogOpenInC8 } from '../Modal/CatalogOpenInC8'


export const SyncFieldButton = observer<{ className?: string, value?: string, isNewSync?: boolean }>(function SyncFieldButton({className, value, isNewSync}) {
  const {strings, detailsStore: {isPublished, isOffline, id, createObjectInRemote, index, isValidForUpload, isDirty, isSyncing: sync, sidebar:{type}, syncDetails}, data,
      syncProgress: {byId}} = useFieldRendererStore(),
    status = id && byId.get(id),
    isSyncing = status?.loading || sync

  return (
    <Fragment>
      {!isOffline && <div className={classNames(
        css.syncTime,
        {[css.disabled]: isSyncing}
      )}>
        {isSyncing ? strings.syncing : value ? <ReactTimeago date={value}/> : strings.never}
      </div>}

      {!isNewSync && <Tooltip2 content={status?.itemId ? strings.syncing : data?.exId ? strings.syncNow : strings.uploadToC8}>
        <div className={css.syncIconContainer}>
          <div className={classNames(css.root, className)}>
            {!isOffline ? 
              <PrimaryIconButton
                disabled={isSyncing || !isValidForUpload || !isPublished}
                onClick={e => syncDetails(id, index)}
                icon={<Icon className={isSyncing ? css.spinnerButton : ''} icon={'refresh'} />}
              /> : <PrimaryButton
                className={css.syncButton}
                disabled={isSyncing || !isValidForUpload  || isDirty}
                onClick={e => createObjectInRemote()}
              >
                {data?.exId && <span className={css.buttonText}>{!data?.exId && `${strings.uploadToC8}`}</span>}
                <Icon className={sync ? css.spinnerButton : ''} icon={sync ? 'refresh' : 'cloud-upload'} />
              </PrimaryButton>
            }
          </div>
          {!isOffline && type === "sidebar" && <CatalogOpenInC8/>}
        </div>
      </Tooltip2>}
    </Fragment>)
})



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/SyncFieldButton.tsx